import React, { useState } from 'react'
import { Table, IconButton, Icon, Row, Col, CheckPicker } from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { maskIdCard } from '../../utils/dataUtil'

export default function TaxSumReportTable({
  schema,
  data,
  loading,
  onSearch,
  onCancel,
  onClick = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [modelType, setModelType] = useState()
  const [handleOnExport, setHandleOnExport] = useState()

  const handleSearch = () => {
    onSearch(modelType)
  }

  const handleCancel = () => {
    setModelType(0)
    onCancel()
  }

  return (
    schema && (
      <>
        <Row style={{ textAlign: 'right', marginBottom: 20 }}>
          {schema.modelType && (
            <>
              <Col lg={2} md={2} sm={24} xs={24}>
                <span>{schema.modelType.label}</span>
              </Col>
              <Col lg={4} md={4} sm={24} xs={24}>
                <CheckPicker
                  sticky
                  searchable={false}
                  data={schema.modelType.options}
                  value={modelType}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    // console.log('x => ', value)
                    setModelType(value)
                  }}
                />
              </Col>
            </>
          )}

          <Col lg={4} md={4} sm={24} xs={24}>
            <SearchButton disabled={false} onClick={handleSearch}>
              ค้นหา
            </SearchButton>
            <CancelButton disabled={false} onClick={handleCancel}>
              ยกเลิก
            </CancelButton>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}></Col>
        </Row>
        <Row>
          <Col
            lg={2}
            md={2}
            sm={24}
            xs={24}
            style={{ textAlign: 'right', marginTop: 10, marginBottom: 20 }}
          >
            <b>{schema.projectCode.label}</b>
          </Col>
          <Col lg={2} md={2} sm={24} xs={24} style={{ marginTop: 10, marginBottom: 20 }}>
            <b>{` : ${schema.projectCode.value || ''}`}</b>
          </Col>
          <Col
            lg={2}
            md={2}
            sm={24}
            xs={24}
            style={{ textAlign: 'right', marginTop: 10, marginBottom: 20 }}
          >
            <b>{schema.projectName.label}</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10, marginBottom: 20 }}>
            <b>{` : ${schema.projectName.value || ''}`}</b>
          </Col>
        </Row>

        <Row style={{ marginBottom: 10 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
              // onClick={handleSubmit(handleOnExport)}
              onClick={(e) => {
                onClick(handleOnExport)
              }}
            >
              Export to Excel
            </IconButton>
          </Col>
        </Row>

        <Table wordWrap autoHeight loading={loading} data={data || []}>
          <Column width={80} align="center">
            <HeaderCell>ลำดับที่</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (!rowData.isRowTotal) {
                  return index + 1
                }
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>เลขประจำตัวผู้เสียภาษี</HeaderCell>
            {/* <Cell dataKey="taxid" /> */}
            <Cell>
              {(rowData) => {
                return <>{maskIdCard(rowData.taxid)}</>
              }}
            </Cell>
          </Column>
          <Column width={200}>
            <HeaderCell>ชื่อผู้มีเงินได้</HeaderCell>
            <Cell dataKey="nameEarner" />
          </Column>
          <Column width={200}>
            <HeaderCell>ที่อยู่ของผู้มีเงินได้</HeaderCell>
            {/* <Cell dataKey="addressEarner" /> */}
            <Cell align="right">
              {(rowData) => {
                if (rowData.isRowTotal) {
                  return <b>{rowData.addressEarner}</b>
                }
                return <span>{rowData.addressEarner}</span>
              }}
            </Cell>
          </Column>
          <Column width={200}>
            <HeaderCell>จำนวนเงินได้ที่จ่ายทั้งปี</HeaderCell>
            {/* <Cell dataKey="amountIncomeYear" />
             */}
            <Cell align="right">
              {(rowData) => {
                if (rowData.isRowTotal) {
                  return (
                    <span
                      style={{ fontWeight: 550 }}
                      className={'cost-total-summary'}
                    >{`${budgetFormat(rowData.amountIncomeYear)}`}</span>
                  )
                }
                return <span>{`${budgetFormat(rowData.amountIncomeYear)}`}</span>
              }}
            </Cell>
          </Column>
          <Column width={250}>
            <HeaderCell>จำนวนเงินภาษีที่หักและนำส่งทั้งปี</HeaderCell>
            {/* <Cell dataKey="amountTaxYear" /> */}
            <Cell align="right">
              {(rowData) => {
                if (rowData.isRowTotal) {
                  return (
                    <span
                      style={{ fontWeight: 550 }}
                      className={'cost-total-summary'}
                    >{`${budgetFormat(rowData.amountTaxYear)}`}</span>
                  )
                }
                return <span>{`${budgetFormat(rowData.amountTaxYear)}`}</span>
              }}
            </Cell>
          </Column>
          <Column width={200}>
            <HeaderCell>เงื่อนไข</HeaderCell>
            <Cell dataKey="condition" />
          </Column>
        </Table>
      </>
    )
  )
}
